const useImageProfessional = () => {

    const loadImageProfessional = (rut) => {
        let url = "";
        //console.log("RUT IMG => ", rut);
        let sede = process.env.REACT_APP_SEDE;

        if(sede == 'Puerto Montt'){
            if(rut.trim() == '108'){
                url = `${process.env.REACT_APP_ROOT_SERVER_PATH}/static/images/img_eco.jpg`;
            } else if (rut.trim() == '94') {
                url = `${process.env.REACT_APP_ROOT_SERVER_PATH}/static/images/51.jpg`;
            } else if (rut.trim() == '86') {
                url = `${process.env.REACT_APP_ROOT_SERVER_PATH}/static/images/78.jpg`;
            } else if (rut.trim() == '51') {
                url = `${process.env.REACT_APP_ROOT_SERVER_PATH}/static/images/43.jpg`;
            } else{
                console.log("SIN IMAGEN PUERTO MONTT => ",rut)
                url = `${process.env.REACT_APP_ROOT_SERVER_PATH}/static/images/img-rx.jpg`;
            }

        }else if(sede == 'Concepción'){
            /* 
            1-9 Ecografía
            3-5 Radiografía
            4-3 Scanner
            5-1 Resonancia
            7-8 Mamografía
            8-6 Procedimiento
            9-4 Densitometría
            10-8 PET-CT
            */
            if(rut.trim() == '19'){
                url = `${process.env.REACT_APP_ROOT_SERVER_PATH}/static/images/img_eco.jpg`;
            } else if (rut.trim() == '43') {
                url = `${process.env.REACT_APP_ROOT_SERVER_PATH}/static/images/43.jpg`;
            } else if (rut.trim() == '51') {
                url = `${process.env.REACT_APP_ROOT_SERVER_PATH}/static/images/51.jpg`;
            } else if (rut.trim() == '78') {
                url = `${process.env.REACT_APP_ROOT_SERVER_PATH}/static/images/78.jpg`;
            } else if (rut.trim() == '94') {
                url = `${process.env.REACT_APP_ROOT_SERVER_PATH}/static/images/94.jpg`;
            } else if (rut.trim() == '108') {
                url = `${process.env.REACT_APP_ROOT_SERVER_PATH}/static/images/108.jpg`;
            }
            else{
                console.log("SIN IMAGEN => ",rut)
                url = `${process.env.REACT_APP_ROOT_SERVER_PATH}/static/images/img-rx.jpg`;
            }
        }else{
            //CHILLAN
            /* 
            ECOGRAFIA ='        78'
            SCANNER/TAC='        86'
            MAMOGRAFIA='        94'
            RESONANCIA='        108'
            DENSITOMETRIA='        140'
            RAYOS='        159'
            */
            if(rut.trim() == '78'){
                url = `${process.env.REACT_APP_ROOT_SERVER_PATH}/static/images/img_eco.jpg`;
            } else if (rut.trim() == '86') {
                url = `${process.env.REACT_APP_ROOT_SERVER_PATH}/static/images/43.jpg`;
            } else if (rut.trim() == '108') {
                url = `${process.env.REACT_APP_ROOT_SERVER_PATH}/static/images/51.jpg`;
            } else if (rut.trim() == '94') {
                url = `${process.env.REACT_APP_ROOT_SERVER_PATH}/static/images/78.jpg`;
            } else if (rut.trim() == '140') {
                url = `${process.env.REACT_APP_ROOT_SERVER_PATH}/static/images/94.jpg`;
            } else if (rut.trim() == '159') {
                url = `${process.env.REACT_APP_ROOT_SERVER_PATH}/static/images/img-rx.jpg`;
            }
            else{
                console.log("SIN IMAGEN => ",rut)
                url = `${process.env.REACT_APP_ROOT_SERVER_PATH}/static/images/img-rx.jpg`;
            }
        }

        return url
    }

    return {
        loadImageProfessional
    }

}

export default useImageProfessional;    